import CommentViewCollapsed from 'annotator/comment-view-collapsed';
import CommentViewExpanded from 'annotator/comment-view-expanded';

import { CommentInputCoreContainerProps } from 'annotator/annotator-types';

const CommentInputCoreContainer = ({
  annotation,
  annotationText,
  assignCommentVariants,
  bulkDeleteMode,
  cancelEdit,
  commentCategory,
  commentCategoryAndType,
  capitalizedCommentCategory,
  commentType,
  commentIcon,
  commentHelpersSummary,
  confirmingDeletion,
  contextWidth,
  editComment,
  handleRestoreAnnotation,
  hasSources,
  inDiscussion,
  isEditable,
  isEditing,
  isEditingDisabled,
  isPanelSelected: isSelected,
  markedForDeletion,
  onCancelRemovingAnnotation,
  onMarkedForDeletionChange,
  onStartRemovingAnnotation,
  keyboardSelectHighlight,
  selectHighlight,
  removeAnnotation,
  removeCitation,
  restorable,
  saveCiteStatus,
  saveComment,
  savingSubmission,
  selectedParagraphIndex,
  showCollapsed,
  viewingAsBellmereQa,
  setBellmereQAResult,
  bellmereQAResults,
  bellmereQAEditable,
  isDone,
  completionPending,
  onToggleCompletion
}: CommentInputCoreContainerProps) => (
  <div className="panel-core-container">
    <div className="comment-view-wrapper">
      {showCollapsed && (
        <CommentViewCollapsed
          annotation={annotation}
          bellmereQAResults={bellmereQAResults}
          viewingAsBellmereQa={viewingAsBellmereQa}
          capitalizedCommentCategory={capitalizedCommentCategory}
          commentCategory={commentCategory}
          commentIcon={commentIcon}
          commentType={commentType}
          isPanelSelected={isSelected}
          isDone={isDone}
          keyboardSelectHighlight={keyboardSelectHighlight}
        />
      )}

      <CommentViewExpanded
        annotation={annotation}
        annotationText={annotationText}
        assignCommentVariants={assignCommentVariants}
        bulkDeleteMode={bulkDeleteMode}
        cancelEdit={cancelEdit}
        commentCategory={commentCategory}
        commentCategoryAndType={commentCategoryAndType}
        capitalizedCommentCategory={capitalizedCommentCategory}
        commentType={commentType}
        commentIcon={commentIcon}
        commentHelpersSummary={commentHelpersSummary}
        confirmingDeletion={confirmingDeletion}
        contextWidth={contextWidth}
        editComment={editComment}
        handleRestoreAnnotation={handleRestoreAnnotation}
        hasSources={hasSources}
        inDiscussion={inDiscussion}
        isEditable={isEditable}
        isEditing={isEditing}
        isEditingDisabled={isEditingDisabled}
        isPanelSelected={isSelected}
        markedForDeletion={markedForDeletion}
        onCancelRemovingAnnotation={onCancelRemovingAnnotation}
        onMarkedForDeletionChange={onMarkedForDeletionChange}
        onStartRemovingAnnotation={onStartRemovingAnnotation}
        keyboardSelectHighlight={keyboardSelectHighlight}
        selectHighlight={selectHighlight}
        removeAnnotation={removeAnnotation}
        removeCitation={removeCitation}
        restorable={restorable}
        saveCiteStatus={saveCiteStatus}
        saveComment={saveComment}
        savingSubmission={savingSubmission}
        selectedParagraphIndex={selectedParagraphIndex}
        viewingAsBellmereQa={viewingAsBellmereQa}
        bellmereQAEditable={bellmereQAEditable}
        setBellmereQAResult={setBellmereQAResult}
        bellmereQAResults={bellmereQAResults}
        isDone={isDone}
        completionPending={completionPending}
        onToggleCompletion={onToggleCompletion}
      />
    </div>
  </div>
);

export default CommentInputCoreContainer;
